// extracted by mini-css-extract-plugin
module.exports = {"primaryNavigation":"PrimaryNavigation-module--primaryNavigation--1HVZs","primaryNavigation__link":"PrimaryNavigation-module--primaryNavigation__link--3N1Hi"};